let turnstileLoaded = false;

function loadTurnstileScript(): Promise<void> {
  if (turnstileLoaded) return Promise.resolve();
  return new Promise((resolve, reject) => {
    const s = document.createElement("script");
    s.src =
      "https://challenges.cloudflare.com/turnstile/v0/api.js?render=explicit";
    s.async = true;
    s.defer = true;
    s.onload = () => {
      turnstileLoaded = true;
      resolve();
    };
    s.onerror = () => reject(new Error("Failed to load Turnstile"));
    document.head.appendChild(s);
  });
}

export async function getTurnstileToken(): Promise<string> {
  await loadTurnstileScript();

  return new Promise((resolve, reject) => {
    // Off-screen invisible container
    const container = document.createElement("div");
    container.style.position = "fixed";
    container.style.top = "-9999px";
    document.body.appendChild(container);

    const turnstile = (window as any).turnstile;
    if (!turnstile) {
      document.body.removeChild(container);
      reject(new Error("Turnstile API not available"));
      return;
    }

    turnstile.render(container, {
      sitekey: process.env.NEXT_PUBLIC_TURNSTILE_SITE_KEY!,
      size: "invisible",
      callback: (token: string) => {
        document.body.removeChild(container);
        resolve(token);
      },
      "error-callback": () => {
        document.body.removeChild(container);
        reject(new Error("Turnstile challenge failed"));
      },
    });
  });
}
